import {CheckboxItem} from "../../../../model/items/checkbox";
import m, {Vnode} from "mithril";
import {LabelItem} from "../../../../model/items/labelItem";

export default class CheckboxTileCell {

    constructor(
        public readonly checkbox: CheckboxItem,
    ) { }

    public view(): Vnode|null {

        if (!this.checkbox.cell.visible) {
            return null;
        }

        const enabled = this.checkbox.cell.enabled;
        const checked = enabled && this.checkbox.getVariable();

        const label = this.checkbox.childrenTags.filter(t => t.tag==='text')[0]?.value;

        return m('.CheckboxTileCell'+(checked ? '.selected' : '')+(enabled ? '' : '.disabled'), {
                onclick: () => this.checkbox.set()
            }, [
                m('label', {}, m.trust(this.checkbox.form.questionary.renderText(label || '✔'))),
            ]
        );
    }

}